import React from 'react';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Button } from '@mui/material';
import { TaskModal } from './TaskModal.tsx';

type AddTaskButtonProps = {
  keyName: string; // i.e taskId (primary key name)
  resource: string; // i.e 'tasks'
  onSaved?: () => void;
};

export const AddTaskButton = ({ keyName, resource, onSaved }: AddTaskButtonProps) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant="contained"
        size="small"
        startIcon={<AddOutlinedIcon fontSize="small" />}
      >
        Add Task
      </Button>
      <TaskModal
        keyName={keyName}
        resource={resource}
        open={open}
        setOpen={setOpen}
        onSaved={onSaved}
      />
    </>
  );
};
